<div class="deu-page">
  @if (loading) {
  <mat-card class="deu-card deu-state-card">
    <mat-card-content>
      <div class="deu-state">
        <mat-icon class="deu-spin">hourglass_top</mat-icon>
        <span>Indlæser deltagere…</span>
      </div>
    </mat-card-content>
  </mat-card>
  } @else if (loadError) {
  <mat-card class="deu-card deu-error-card">
    <mat-card-content>
      <div class="deu-state deu-state--error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ loadError }}</span>
      </div>
    </mat-card-content>
  </mat-card>
  } @else {
  <section class="deu-tables-section">
    <mat-card class="deu-card deu-table-card">
      <div class="deu-section-header">
        <div class="deu-section-heading">
          <mat-icon>groups</mat-icon>
          <div>
            <h2>Deltagere</h2>
            <p>Tilmeldte deltagere med status og rolle. Rediger direkte i tabellen.</p>
          </div>
        </div>
        @if (canEditEvent() | async) {
        <div class="deu-toolbar">
          <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="onMailParticipants()"
          >
            <mat-icon>mail</mat-icon>
            Mail
          </button>
          <button
            type="button"
            mat-stroked-button
            color="primary"
            (click)="onCopyTemplate()"
          >
            <mat-icon>content_copy</mat-icon>
            Kopiér
          </button>
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="onAddUsers()"
          >
            <mat-icon>person_add</mat-icon>
            Tilføj brugere
          </button>
        </div>
        }
      </div>
      <mat-card-content>
        <app-dynamic-table [dynamicInput]="participantsTableInput"></app-dynamic-table>
      </mat-card-content>
    </mat-card>

    @if (showWaitlistSection) {
    <mat-card class="deu-card deu-table-card">
      <div class="deu-section-header">
        <div class="deu-section-heading">
          <mat-icon>playlist_add</mat-icon>
          <div>
            <h2>Venteliste</h2>
            <p>Deltagere der afventer en ledig plads på eventet.</p>
          </div>
        </div>
      </div>
      <mat-card-content>
        <app-dynamic-table [dynamicInput]="waitlistTableInput"></app-dynamic-table>
      </mat-card-content>
    </mat-card>
    }

    <mat-card class="deu-card deu-table-card">
      <div class="deu-section-header">
        <div class="deu-section-heading">
          <mat-icon>event_busy</mat-icon>
          <div>
            <h2>Afbud</h2>
            <p>Brugere der har meldt afbud eller er sat til status afbud.</p>
          </div>
        </div>
      </div>
      <mat-card-content>
        <app-dynamic-table [dynamicInput]="cancellationsTableInput"></app-dynamic-table>
      </mat-card-content>
    </mat-card>

    <mat-card class="deu-card deu-table-card">
      <div class="deu-section-header">
        <div class="deu-section-heading">
          <mat-icon>school</mat-icon>
          <div>
            <h2>Instruktører</h2>
            <p>Instruktører tilknyttet eventet.</p>
          </div>
        </div>
      </div>
      <mat-card-content>
        <app-dynamic-table [dynamicInput]="instructorsTableInput"></app-dynamic-table>
      </mat-card-content>
    </mat-card>
  </section>
  }
</div>
